export default "__VITE_ASSET__8f019e67__"